/**
 * Controller used for /profile
 */

import Services from '../services/services';
import HeaderViewModel from '../viewModels/headerViewModel';
import EventController from './event';

class ErrorController {
    constructor() {
        this.EventController = EventController;
            // set booleans to determine need for auth/reauth
            // attemptAuth: true,
            // attemptReauth: true
    }

    handleErrors(err, model, viewModel, controller, EventController, selector, evt = '', store) {
        // update view state: set errors to true
        if (parseInt(err.status) === 401) {
            //kick the person up to the login module
            console.log('properly catching 401s now!');

            // disables loading gif when unauthed
            controller.stopLoadingGif();

            if (Services.getCookieByName('loginAuth')) {
                console.log("let's try and reauth");
                controller.render(store);
                // AuthController.reauth
                // new promise chain, pass in current controller and cookie reauth value
                // if it comes back success run controller.render()
            } else if (Services.getCookieByName('loginReauth')) {
                // try and reauth
                console.log('reauth please!');
            } else {
                console.log('fire modal');
                // fire off modal

                let intervalId;

                function runInterval() {
                    intervalId = setInterval(checkForAngular, 100);
                }

                function checkForAngular() {
                    if (typeof angular !== 'undefined') {
                        var scope = angular.element(jQuery('.header')).scope();

                        if (typeof scope !== 'undefined') {
                            scope.toggleLoginClicked();

                            scope.$on('urbn-login:success', function(event, status, response_data, response_headers) {
                                console.log('we have successfully logged in!');
                                controller.render(store);
                            });

                            clearInterval(intervalId);
                        }
                    }
                }

                runInterval();
            }
        } else if (parseInt(err.status.code, 10) === 400 || parseInt(err.status.code, 10) === 500 || parseInt(err.status.code, 10) === 504 || parseInt(err.status.code, 10) === 412) {
            if (err.entity.code === 'NO_STORES') {
                this.resolveNoStores(err);
            } else {
                if (err.entity.code === 'INVALID_EMPLOYEE_ID') {
                    this.removeEmployeeIdOnError(model);
                }
                this.validationError(err, model, viewModel, controller, evt, this.EventController, selector, store);
            }
        } else if (parseInt(err.status, 10) === 404) {
            if (err.endpoint.endsWith('history')) {
                model.noOrders(model, viewModel)
                    .then(() => {
                        controller.render(store);
                    });
            }
        } else if (parseInt(err.status.code, 10) === 409) {
            if (err.entity.code === 'DUPLICATE_EMPLOYEE_PROFILE_FOUND') {
                this.removeEmployeeIdOnError(model);
            }
            this.duplicateError(err, model, viewModel, controller, evt, this.EventController, selector, store);
        }
        // else if (parseInt(err.status) === 500 || parseInt(err.status) === 504) {
        //     this.showErrorModal(err, model, viewModel, controller,evt,EventController,selector, store);
        // }
        else {
            console.log('you broke everything.')
        }
    }

    showErrorModal(err, model, viewModel, controller, evt, EventController, selector, state) {
        controller.stopLoadingGif();

        jQuery('#error-modal').addClass('active');
        if (jQuery('#error-modal .message').html() == '' && jQuery('#error-contact-us').html() == '') {
            jQuery('#error-modal .message').html(getTranslatedError(err, state));
            jQuery('#error-contact-us').html(getTranslatedError(err, state));
        }

        HeaderViewModel.viewStates.showErrorModal = true;
    }

    removeEmployeeIdOnError(model) {
        return new Promise(function(resolve, reject) {
            resolve(model.profile.employee.employeeId = '');
        });
    }

    modelUpdate(err, model) {
        return new Promise(function(resolve, reject) {
            resolve(model.error.push({
                errorGenerator: '',
                message: err.data.message
            }));
        });
    }

    validationError(err, model, viewModel, controller, evt, EventController, selector, store) {
        this.errorPromiseHelper(err, store)
            .then(message => {
                return model.attachValidationMessages(err, message);
            })
            .then(updatedModel => {
                return model.attachErrorLocation(selector);
            })
            .then(updatedModel => {
                return viewModel.updateViewState('showErrors', true);
            })
            .then(updatedModel => {
                return EventController.removeAllEvents(viewModel);
            })
            .then(updatedViewModel => {
                return controller.render(store);
            })
            .catch(err => {
                this.handleErrors(err);
            })
    }

    duplicateError(err, model, viewModel, controller, evt, EventController, selector, store) {
        this.errorPromiseHelper(err, store)
            .then(message => {
                return model.attachValidationMessages(err, message);
            })
            .then(updatedModel => {
                return model.attachErrorLocation(selector);
            })
            .then(updatedModel => {
                return viewModel.updateViewState('showErrors', true);
            })
            .then(updatedModel => {
                return EventController.removeAllEvents(viewModel);
            })
            .then(updatedViewModel => {
                return model.revertForm(err);
            })
            .then(updatedModel => {
                return controller.render(store);
            })
            .catch(err => {
                this.handleErrors(err);
            })
    }

    /**
     * A method that handles an invalid input
     * on the favorite store form.
     *
     * @param {Object} err
     * @returns {Promise}
     */
    resolveNoStores(err) {
        return Promise.resolve(true)
    }

    /**
     * Helper function to return the current error message as a promise
     * @param  {object} err   The current error object
     * @param  {object} state The current state of the redux store
     * @return {object}       A promise object containing either the current error as a string,
     * or an object
     */
    errorPromiseHelper(err, state) {
        if (err.status.code && this.getTranslatedError(err, state)) {
            return Promise.resolve(this.getTranslatedError(err, state));
        } else {
            const address1Error = this.address1ErrorHandling(err);

            if (err.entity.code) {
                console.error(`missing localized slug: ERROR_ACCOUNT_${err.entity.code}`)
            } else if (address1Error.status) {
                console.error(`missing localized slug: ERROR_ACCOUNT_${err.status.field_errors[address1Error.index].code}`)
            }

            return Promise.resolve(err);
        }
    }

    /**
     * Helper function to get the localized error text via ENUM in error code
     * @param  {object} err   The current error object
     * @param  {object} state The current state of the redux store
     * @return {string}       The localized error string from core/contentful
     */
    getTranslatedError(err, state) {
        const address1Error = this.address1ErrorHandling(err);
        let errorSlug;
        if (address1Error.status) {
            errorSlug = `ERROR_ACCOUNT_${err.entity.field_errors[address1Error.index].code}`;
        } else if (_.get(err, 'entity.field_errors', []).length > 0 && !address1Error) {
            errorSlug = `ERROR_ACCOUNT_${err.entity.field_errors[0].code}`;
        } else {
            errorSlug = `ERROR_ACCOUNT_${err.entity.code}`;
        }
        if (state.core.localizations.containers.errorLocalization[errorSlug]) {
            return state.core.localizations.containers.errorLocalization[errorSlug];
        } else {
            return errorSlug;
        }
    }

    /**
     * Helper function to get the localized error text via ENUM in error code
     * @param  {object} err   The current error object
     * @return {object} resonse   The status and index of ADDRESS1_TOO_LONG
     */
    address1ErrorHandling(err) {
        if (err.entity.field_errors) {
            for (let i = 0; i <= err.entity.field_errors.length; i++) {
                if (err.entity.field_errors[i].code === 'ADDRESS1_TOO_LONG') {
                    return {
                        status: true,
                        index: i
                    };
                } else {
                    return false;
                }
            }
        } else {
            return false;
        }
    }
}

//Create an object from the ErrorController class
let errorController = new ErrorController();

//Export object created from ErrorController class
export default errorController;
